import Swal from 'sweetalert2';
import {datepicker} from 'bootstrap-datepicker';

require('jquery.cookie');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.es');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.pt');
require('bootstrap-datepicker/js/locales/bootstrap-datepicker.he');
require('bootstrap-fileinput');
require('bootstrap-fileinput/js/locales/es.js');
require('bootstrap-fileinput/js/locales/pt.js');
require('bootstrap-fileinput/js/locales/he.js');
require('bootstrap-fileinput/js/plugins/piexif');
require('bootstrap-fileinput/themes/fa6/theme');

// Clipboard
let clipboard = () => {
    $(document).on('click', '[data-copy-text]', function () {
        let text = $(this).data('copy-text');
        let $input = `<input value="${text}" id="copy-text">`;
        $('body').append($input);
        let $id = $('#copy-text');
        $id.select();
        document.execCommand("copy");
        $id.remove();
    });
};

// Get cookie
let getCookie = name => {
    name = name + "=";
    let ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

// Init datepicker 18 years old
let initDatepicker18YearsOld = () => {
    let locale = getCookie('language-js').substr(0, 2);
    $('.datepicker').datepicker({
        language: locale,
        autoclose: true,
        endDate: '-18y',
        format: 'dd-mm-yyyy',
        orientation: 'bottom'
    });
};

// Init datepicker end today
let initDatepickerEndToday = () => {
    let locale = getCookie('language-js').substr(0, 2);
    $('.datepicker').datepicker({
        language: locale,
        autoclose: true,
        todayBtn: true,
        todayHighlight: true,
        endDate: '0d',
        format: 'dd-mm-yyyy',
        orientation: 'bottom'
    });
};

// Init file input
let initFileInput = (preview, field) => {
    let locale = getCookie('language-js').substr(0, 2);
    let config = {
        language: locale,
        theme: 'fa6',
        showCaption: false,
        showRemove: false,
        showUpload: false,
        showCancel: false,
        showClose: false,
        dropZoneEnabled: false,
        allowedFileExtensions: ['png', 'jpg', 'webp', 'pdf', 'jpeg', 'heic', 'heif'],
        msgProcessing: '',
        previewClass: 'd-flex justify-content-center border-0',
        browseClass: 'btn btn-theme',
        maxFileSize: 2048
    };

    if (preview !== undefined) {
        config.defaultPreviewContent = preview;
    }

    if (field !== undefined) {
        $(`#${field}`).fileinput(config);

    } else {
        $('input[type="file"]').fileinput(config);
    }
};

// Init select2
let initSelect2 = () => {
    $('select').select2({
        width: '100%'
    });
};

// Set cookie
let setCookie = (name, value, days) => {
    let d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
};

// Swal error
let swalError = json => {
    // Handle cases where responseJSON might be undefined
    const responseData = json.responseJSON || {};
    
    if (json.status === 422) {
        let html = '<ul>';
        if (responseData.errors) {
            $.each(responseData.errors, function (index, value) {
                html += '<li>' + value + '</li>';
            });
        } else {
            html += '<li>Validation error occurred</li>';
        }
        html += '</ul>';

        Swal.fire({
            title: responseData.message || 'Validation Error',
            html: html,
            icon: 'error',
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: 'Close'
        });

    } else if (json.status === 401) {
        const data = {
            title: (responseData.data && responseData.data.title) || 'Authentication Required',
            message: (responseData.data && responseData.data.message) || 'Please log in to continue',
            button: (responseData.data && responseData.data.button) || { text: 'Login', url: '/login' },
            close: (responseData.data && responseData.data.close) || 'Cancel'
        };
        Swal.fire({
            title: data.title,
            text: data.message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: data.button.text,
            cancelButtonText: data.close,
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href = data.button.url;
            }
        });
    } else {
        Swal.fire({
            title: (responseData.data && responseData.data.title) || 'Error',
            text: (responseData.data && responseData.data.message) || 'An unexpected error occurred',
            icon: 'error',
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: (responseData.data && responseData.data.close) || 'Close'
        });
    }
};


let swalErrorWithActionButton = (json, resolve = null) => {
  const { data } = json.responseJSON;
    const params = {
        title: (data && data.title) || 'Error',
        message: (data && data.message) || 'An unexpected error occurred',
        buttonText: (data && data?.button?.text) || "Action button",
        buttonUrl: (data && data?.button?.url) || null,
        close: (data && data.close) || 'Close'
    };
    Swal.fire({
        title: params.title,
        text: params.message,
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: params.buttonText,
        cancelButtonText: params.close,
    }).then((result) => {
        if (result.isConfirmed) {
            if (params.buttonUrl !== null) {
                window.location.href = params.buttonUrl;
            }
        }
    });
};

// Swal success no button
let swalSuccessNoButton = json => {
    Swal.fire({
        title: json.data.title,
        text: json.data.message,
        icon: 'success',
        showConfirmButton: false
    });
};

// Swal success with button
let swalSuccessWithButton = (json, resolve = null) => {
    let alert = Swal.fire({
        title: json.data.title,
        text: json.data.message,
        icon: 'success',
        confirmButtonText: json.data.close
    });

    if (typeof resolve === 'function') {
        alert.then(resolve)
    }
};

export {
    clipboard,
    getCookie,
    initDatepicker18YearsOld,
    initDatepickerEndToday,
    initFileInput,
    initSelect2,
    setCookie,
    swalError,
    swalSuccessNoButton,
    swalSuccessWithButton,
    swalErrorWithActionButton
};